<template>
  <v-card
    flat
    class="mb-5 pb-5"
    style="border-bottom: solid 1px #e6e6e6; margin: 0px;"
  >
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <p class="font-weight-black">
            <slot name="title" />
          </p>
          <p class="font-weight-light">
            <slot name="description" />
          </p>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <slot name="form" />
        </v-col>
      </v-row>
      <v-card-actions class="mt-10 mb-5">
        <slot name="button" />
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>
